import { buildVenuePath } from '../utils/venueRouting';
import React, { useContext, useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import AppContext from '../contexts/AppContext';
import BackButton from '../components/BackButton';
import { Carousel } from 'react-responsive-carousel';
import AdvTabs from '../components/AdvTabs';
import 'quill/dist/quill.snow.css';
import { sanitizeAndParseHtml } from '../utils/HtmlParser';

const shuffleArray = (array) => {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
};

const Article = () => {
    const { id } = useParams();
    const { articleInfo, hotelInfo, venueId } = useContext(AppContext);
    const [article, setArticle] = useState(null);
    const [relatedArticles, setRelatedArticles] = useState([]); // 用于存储随机的其他文章
    const navigate = useNavigate();

    useEffect(() => {
        if (articleInfo) {
            const currentArticle = articleInfo.find(data => data.id === id);
            setArticle(currentArticle);
            const otherArticles = articleInfo.filter(data => data.id !== id);
            const randomArticles = shuffleArray(otherArticles).slice(0, 3);
            setRelatedArticles(randomArticles);
        }
        window.scrollTo(0, 0);
    }, [articleInfo, id]);

    useEffect(() => {
        const mainEl = document.querySelector('.main-scroll-container');
        if (mainEl) {
          mainEl.scrollTo(0, 0);
          // console.log("id changed")
        }
      }, [id]);

    if (!article || !hotelInfo) {
        return <div>Loading...</div>;
    }

    const themeColor = hotelInfo.theme?.primaryColor || hotelInfo.theme?.color || 'rgb(0,0,0)';
    const fontColor = hotelInfo.theme?.fontColor || 'rgb(0,0,0)';

    // 处理字符串中的 carousel 链接，将它们分割成数组
    const renderCarousel = (detail) => {
        const images = detail
        // const images = detail.split(';'); // 通过 `;` 来分割图片 URL
        return (
            <Carousel
                showArrows={true}
                showThumbs={false}
                infiniteLoop={true}
                showIndicators={false}
                autoPlay={true}
                showStatus={false}
                className="w-full h-full"
            >
                {images.map((img, index) => (
                    <div key={index} className="w-full h-full">
                        <img
                            src={img}
                            alt={`Carousel ${index + 1}`}
                            className="object-cover w-full aspect-2 xs:max-w-md xs:max-h-64"
                        />
                    </div>
                ))}
            </Carousel>
        );
    };

    // 根据类型渲染段落，并插入广告Tab
    const renderParagraphs = (paragraphs) => {
        let renderedCount = 0;

        return paragraphs.map((paragraph, index) => {
            let element = null;

            // 根据段落类型进行渲染
            if (paragraph.type === 'text') {

                element = (
                    <div
                        key={index}
                        className="ql-container ql-snow my-4 mx-4"
                        style={{
                            border: 'none',
                            boxShadow: 'none',
                            backgroundColor: 'transparent'
                        }}
                    >
                        <div className="content-body">
                            {sanitizeAndParseHtml(paragraph.detail || '', venueId)}
                        </div>

                    </div>


                );

            } else if (paragraph.type === 'image') {
                element = (
                    <div className="mx-4 my-4" key={index}>
                        <img src={paragraph.detail} alt={`Article ${index + 1}`} className="object-cover w-full aspect-2 xs:max-w-md xs:max-h-64" />
                    </div>
                );
            } else if (paragraph.type === 'carousel') {
                element = (
                    <div key={index} className="my-4 mx-4">
                        {renderCarousel(paragraph.detail)}
                    </div>
                );
            }
            if (element) {
                renderedCount++;
            }
            // 如果已渲染了三个段落，且上一个段落是 text 类型，插入广告
            if (renderedCount >= 3 && paragraph.type === 'text') {
                renderedCount = 0;
                return (
                    <div key={index}>
                        {element}
                        <AdvTabs origin={'Article'} />
                    </div>
                );
            }

            return element;
        });
    };

    // 渲染随机文章的函数
    const renderRelatedArticles = () => {
        return relatedArticles.map(article => (
            <div key={article.id} className="border rounded-lg shadow-md my-4 max-w-md w-3/4">
                <img src={article.image} alt={article.name} className="w-full aspect-2 object-cover" />
                <div className="p-4">
                    <p className="font-semibold pb-2">{article.name}</p>
                    <p className="text-sm" style={{ color: fontColor }}>{article.description.split(' ').slice(0, 15).join(' ')}...</p>
                    <div className="flex justify-end mt-4">
                        <button onClick={() => navigate(buildVenuePath(`/article/${article.id}`, venueId))} className="mt-4 rounded-full border-2 px-2 py-1 text-xs" style={{ color: themeColor, borderColor: themeColor }}>Read More</button>
                    </div>
                </div>
            </div>
        ));
    };

    return (
        <div>
            <BackButton />
            <p className="text-lg font-semibold my-4 mx-4" style={{ color: themeColor }}>{article.name}</p>
            <div className="max-w-md mx-auto">
                {renderParagraphs(article.paragraphs)}
            </div>

            {/* Discover more section */}
            <div className='bg-gray-100 px-4 py-8'>
                <p className='text-lg font-semibold text-center' style={{ color: themeColor }}>Discover more</p>
                <div className="max-w-md mx-auto flex flex-col items-center">
                    {renderRelatedArticles()}
                </div>
            </div>
        </div>
    );
};


export default Article;
